import { useProperty } from '@eti/providers';
import { ProductCardLayoutType } from '../../common/models/product';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useProductData } from '../../common/hook/useProductData';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import { AIR_HELP } from '../../products';
import { useIsSelected } from '../../single-choice/utils/selection';
import { TrustpilotWidget } from './TrustpilotWidget';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = AIR_HELP;
const sharedTexts = {
  readMoreContent: 'airHelpReadMoreModalContent',
  title: 'airHelpTitle'
};
const mainCardTranslations = {
  ...sharedTexts,
  additionalInformation: 'airHelpAdditionalInformation',
  abstractContent: 'airHelpAbstract',
  upSell: 'airHelpUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'airHelpAbstractSmallCard',
    upSell: 'airHelpUpSellTextSmallCard'
  }
};
const AirHelp = ({
  className,
  form,
  layoutType = MAIN_CARD_LAYOUT,
  order,
  productCode,
  productPosition,
  sellSpecification
}) => {
  const {
    p
  } = useProperty();
  const isSelected = useIsSelected(form, PRODUCT_NAME);
  const texts = translations[layoutType] || {};
  const businessId = p('TravelerDetails.Product.AirHelp.TrustPilotRatingBusinessId');
  const {
    productData,
    rootElement
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    productType: 'traveler',
    sellSpecification,
    texts
  });
  if (!productData) {
    return null;
  }
  switch (layoutType) {
    case ProductCardLayoutType.Small:
      return /*#__PURE__*/_jsx(SmallCardLayout, {
        productData: productData,
        ref: rootElement
      });
    case ProductCardLayoutType.Main:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: productData,
        ref: rootElement,
        children: businessId && /*#__PURE__*/_jsx(ProductLayout.Body, {
          children: /*#__PURE__*/_jsx(TrustpilotWidget, {
            businessId: businessId
          })
        })
      });
  }
};
export default AirHelp;
//# sourceMappingURL=AirHelp.js.map